<template>
  <div class="basic-layout">
    <GloablHeader />
    <!-- 只有在非产品详情页才显示轮播图和产品列表 -->
    <template v-if="!isProductDetailPage">
      <!-- 轮播图组件 - 放在头部导航栏下方 -->
      <CarouselComponent />
      <!-- 产品展示组件 - 放在轮播图下方 -->
      <ProductDisplay />
    </template>
    <main class="main-content">
      <router-view v-slot="{ Component }">
        <transition name="fade" mode="out-in">
          <component :is="Component" />
        </transition>
      </router-view>
    </main>
    <GlobalFooter />
    <!-- 添加悬浮联系按钮 -->
    <FloatingContactButtons />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import GloablHeader from '../components/GloablHeader.vue';
import GlobalFooter from '../components/GlobalFooter.vue';
import FloatingContactButtons from '../components/FloatingContactButtons.vue';
import CarouselComponent from '../components/CarouselComponent.vue';
import ProductDisplay from '../components/ProductDisplay.vue';

const route = useRoute();

// 判断是否是详情页（产品详情或菜单详情或体验申请表单或FAQ页面）
const isProductDetailPage = computed(() => {
  return route.path === '/product-detail' || route.path === '/topic-detail' || route.path === '/application-form' || route.path === '/faq';
});
</script>
<style scoped>
/* 移除可能影响层级的样式 */
#basicLayout {
  width: 100%;
  max-width: 100vw;
}

.layout-container {
  width: 100%;
  max-width: 100vw;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.main-content {
  color: white;
  padding-top: 20px; /* 减少顶部padding，因为轮播图已经占了空间 */
  padding-bottom: 20px; /* 为页脚留出空间 */
  padding-left: 0;
  padding-right: 0;
  margin: 0;
  width: 100%;
  flex: 1; /* 让main-content占据剩余空间 */
}

/* 轮播图容器样式调整 */
:deep(.carousel-container) {
  margin-top: -1px; /* 避免与头部导航栏之间出现间隙 */
}
</style>
